import React from 'react'
import Navbar from '../Components/Header'
import Footer from '../Components/Footer'
import PageTitle from '../Components/PageTitle'
import { Helmet } from 'react-helmet'
import ImportItemList from '../Components/importItems'

function ItmportItems() {
  return (
    <>
    <Helmet>
    <meta name='description' content='we are importing electronic home applience'/>
                <title>Products - Tisson Lanka</title>
                <link rel="canonical" href="/ItmportItems" />
    </Helmet>
    <Navbar/>
    <PageTitle content={'Imported Products'}/>
    <ImportItemList/>
    <Footer/>
    </>
  )
}

export default ItmportItems